// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.containerPrincipal{
		display: flex;
		flex: 1 1;
		width:100%; 
		flex-direction : column;
		align-items : flex-start
	}

.centerView{
		display: flex;
        justify-content:center;
        align-items:center
    }
`, "",{"version":3,"sources":["webpack://./src/assets/css/Principais.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAO;EACP,UAAU;EACV,uBAAuB;EACvB;CACD;;AAED;EACE,aAAa;QACP,sBAAsB;QACtB;IACJ","sourcesContent":[".containerPrincipal{\r\n\t\tdisplay: flex;\r\n\t\tflex: 1;\r\n\t\twidth:100%; \r\n\t\tflex-direction : column;\r\n\t\talign-items : flex-start\r\n\t}\r\n\r\n.centerView{\r\n\t\tdisplay: flex;\r\n        justify-content:center;\r\n        align-items:center\r\n    }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
